<template>
  <nav
      class="font-sans flex items-center justify-between text-center py-4 px-6 bg-white shadow sm:items-baseline w-full xs:px-2 sm:px-4 md:px-8 lg:px-16 xl:px-16 2xl:px-16">
    <div class="mb-2 flex gap-3 items-center content-center sm:mb-0">
      <p @click="showSideBar " class="cursor-pointer block px-2 py-1">
        <font-awesome-icon icon="bars" class="text-gray-500 text-lg " ></font-awesome-icon>
      </p>

      <router-link to="/" class="text-2xl no-underline flex text-gray-700 hover:text-blue-dark">
        <img src="/img/logo.d8e482e0.png" class="block" alt="Sisam" />
      </router-link>
    </div>
    <div>
      <dropdown :label="getUserInfo.username"></dropdown>
    </div>
  </nav>
</template>

<script>
import dropdown from "./dropdown";
import {mapGetters, mapActions} from 'vuex'

export default {
  name: "navbar",
  components: {
    dropdown
  },
  methods: {
    ...mapActions({
      setShowSideBar: 'utils/setShowSideBar'
    }),
    showSideBar() {
      let id=document.getElementById('')
      this.setShowSideBar(!this.getShowSideBar)
    }
  },
  computed: {
    ...mapGetters({
      getUserInfo: 'getUserInfo',
      getShowSideBar: "utils/getShowSideBar"
    })
  }
}
</script>

<style scoped>

</style>